import { Font } from "../../../../util/config-fonts";
import "../../../../styles/css/pg-product.css";

function PgProductNote({ txt = String, onNoteChanged = () => { } }) {
  return (
    <div className="pgProductNote">
      <p style={{ margin: 0, marginBottom: 3, fontSize: Font.Description }}>
        Note
      </p>
      <textarea
        style={{ margin: 0, width: "100%", resize: "vertical" }}
        value={txt}
        onChange={(rs) => onNoteChanged(rs.currentTarget.value)}
      />
    </div>
  );
}

export default PgProductNote;